// extracted by mini-css-extract-plugin
export default {"data-room-images__container":"style_data-room-images__container__MWzGd","data-room-images__box":"style_data-room-images__box__VOb6b"};